// NASA's Blue Marble clouds as a bundled 1 km tile pyramid, built by
// scripts/build-cloud-imagery.mjs from the original 43200x21600 visible
// layer (MODIS Terra, 2001 day 210), with the swath floor removed and the
// polar and high-latitude gaps filled from NASA's own IR composite. The same
// build writes public/textures/earth_clouds.jpg, so the 8K map and the tiles
// are one image at two resolutions.
//
// Grid: equirectangular CRS84, 512 px tiles, rootSpan 288 as in
// src/rocketry/planetimagery.js, levels 3..6 (36, 18, 9 and 4.5 degree
// tiles; level 6 is 0.98 km per pixel at the equator). Paths are
// {z}/{y}/{x}.webp with y counted from the north and x from -180 lon.
// There is no remote tile server: every tile ships with the app.
//
// Tiles hold data values (createPlanetImagery linear: true). Values are
// stored with an offset so clear sky is never 0, because the streamer reads
// a 0 texel as "no imagery here" and would fall back to the parent. Decode
// the sampled channel s (0..1) as
//   cover = max(0.0, (s * 255.0 - OFFSET) / (255.0 - OFFSET))
// which gives the same 0..1 scale as earth_clouds.jpg. Lossy WebP leaves
// R, G and B within a level or two of each other; read one channel.
import { CLOUD_IMAGERY_BUILD } from './cloudImageryBuild.js';

export const CLOUD_IMAGERY_DATASET = 'bluemarble-clouds-2001210';
export const CLOUD_IMAGERY_DATE = '2001-07-29';
// The build (scripts/build-cloud-imagery.mjs) writes a hash of the tiles into
// cloudImageryBuild.js, so a rebuild with new tiles is a new cache.
export const CLOUD_IMAGERY_CACHE = `clouds-${CLOUD_IMAGERY_DATASET}-${CLOUD_IMAGERY_BUILD}`;
export const CLOUD_IMAGERY_PATH = `/textures/cloud-tiles/${CLOUD_IMAGERY_DATASET}`;
export const CLOUD_IMAGERY_EXT = 'webp';
export const CLOUD_IMAGERY_OFFSET = 8;
export const CLOUD_IMAGERY_GRID = { tileSize: 512, rootSpan: 288, rootLevel: 3, pageLevel: 6, maxLevel: 6 };
export const cloudImageryUrl = (z, x, y) => `${CLOUD_IMAGERY_PATH}/${z}/${y}/${x}.${CLOUD_IMAGERY_EXT}`;

export const CLOUD_IMAGERY_CREDIT = 'NASA Visible Earth, Blue Marble: Clouds (MODIS Terra, 2001)';
// Visible Earth record #57747 now redirects to a generic page; this NASA
// feature describes the Blue Marble 1 km set the clouds belong to.
export const CLOUD_IMAGERY_CREDIT_URL = 'https://science.nasa.gov/earth/earth-observatory/the-blue-marble-true-color-global-imagery-at-1km-resolution/';
// The build's inputs, cached in scripts/data/cloud-source/. Byte counts are
// the server's Content-Length, checked after every download.
export const CLOUD_IMAGERY_SOURCES = [
  { file: 'cloud.W.2001210.21600x21600.png', bytes: 210808929, url: 'https://eoimages.gsfc.nasa.gov/images/imagerecords/57000/57747/cloud.W.2001210.21600x21600.png' },
  { file: 'cloud.E.2001210.21600x21600.png', bytes: 211800444, url: 'https://eoimages.gsfc.nasa.gov/images/imagerecords/57000/57747/cloud.E.2001210.21600x21600.png' },
  { file: 'cloud_combined_8192.tif', bytes: 35870468, url: 'https://eoimages.gsfc.nasa.gov/images/imagerecords/57000/57747/cloud_combined_8192.tif' }
];
